<script>
import {
  notificationMethods,
  contentMethods,
  courseMethods,
  examMethods,
  uploadMethods,
  questionMethods
} from "@/state/helpers";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
import {required} from "vuelidate/lib/validators";
import Cookies from "js-cookie";
import {mapActions} from 'vuex';

/**
 * Advanced table component
 */
export default {
  props: {
    courseId: {
      type: String,
      required: true
    },
    examId: {
      type: String,
      required: true
    }
  },


  page: {
    title: "Sınav Detay",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast,
  },
  data() {
    return {
      selectedQuestionType: 'multiple',
      addSubmitted: false,
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      items: [],
      //
      questionFields: [
        {
          key: "name",
          label: "Soru Adı",
        },
        {
          key: "type",
          label: "Soru Tipi",
        },
        {
          key: "isActive",
          label: "Durum",
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      quillOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['link'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['clean']
          ]
        }
      },
      //
      contents: [],
      showContentModal: false,
      contentsLoaded: false,
      //
      exams: [],
      showExamModal: false,
      examsLoaded: false,
      noExamDeleteModal: false,
      examEditId: "",
      examFields: [
        {
          key: "name",
          label: 'Başlık'
        },
        {
          key: "examType",
          label: 'Tipi'
        },
        {
          key: "duration",
          label: 'Süre'
        },
        {
          key: "detail",
          label: "Detay",
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      questionEditModal: false,

      options: [
        {label: 'Çoktan Seçmeli', value: 'multiple'},
        {label: 'Serbest Alan', value: 'single'},
      ],
      correctAnswerIndex: -1,
      multipleChoiceOptions: [
        {option: 'Şık 1', correctAnswerOption: false},
        {option: 'Şık 2', correctAnswerOption: false},
        {option: 'Şık 3', correctAnswerOption: false},
        {option: 'Şık 4', correctAnswerOption: false},
      ],
      //
      customer: {},
      course: {},
      productTransactions: [],
      title: "Kurs Detay",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Kurslar",
          href: "/courses"
        },
        {
          text: "Kurs Detay",
          active: true,
        },
      ],
      currentUser: JSON.parse(Cookies.get('user')),
      editSubmitted: false,
      noDeleteModal: false,
      //
      deleteModal: false,
      deleteId: '',
      editId: "",
      //
      coursesLoaded: false,
      jointCourseFilter: '',
      personsLoaded: false,
      formSelectPersons: [],
      productsLoaded: false,
      formSelectProducts: [],
      formSelectJointCourses: [],
      selectedJointCourse: {},
      selectedEditJointCourse: {},
      quantityError: false,
      productId: 0,
      totalRows: 1,
      page: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "createdAt",
      sortDesc: false,
      addForm: {
        name: "",
        type: "",
        options: [
          null
        ],
        correctAnswerText: null,
        isActive: false,
      },
      editForm: {
        name: "",
        type: "",
        options: [
          null
        ],
        correctAnswerText: null,
        isActive: false,
      },
    };
  },

  validations: {
    addForm: {
      name: {required},
      /* type: {required},
       options: {required},

       correctAnswerText: {required},
       isActive: {required},*/
    },
    editForm: {
      name: {required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
  },
  watch: {
    page(newPage) {
      this.getQuestions(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getQuestions();
        } else {
          this.page = 1;
        }
      }
    },
    jointCustomerFilter(newFilter) {
      if (newFilter.length > 2) {
        this.getCoursesForFormSelect(newFilter)
      } else {
        this.formSelectJointCustomers = [];
      }
    },
  },
  mounted() {
    // this.getExam()
    this.getCourse();
    //  this.getExams();
    this.getQuestions();
  },
  methods: {
    ...contentMethods,
    ...courseMethods,
    ...examMethods,
    ...notificationMethods,
    ...uploadMethods,
    ...questionMethods,
    ...mapActions('exam', ['createExam']),
    handleQuestionTypeChange() {
      this.selectedQuestionType = 'multiple';
    },
    getCourse() {
      this.itemsLoaded = false
      this.fetchCourse({id: this.$route.params.courseId}).then(res => {
        this.course = res
        this.itemsLoaded = true
      })
    },
    getQuestions(page = this.page) {
      this.itemsLoaded = false;
      this.fetchQuestions({
        page,
        limit: this.perPage,
        search: this.search,
        courseId: this.$route.params.courseId,
        examId: this.$route.params.examId
      })
          .then((res) => {
            this.totalRows = res.total;
            this.items = res.docs;
            this.itemsLoaded = true;
          })
          .catch(() => {
            return
          });
    },
    getExams(page = this.page) {
      this.itemsLoaded = false;
      this.fetchExams({
        page,
        limit: this.perPage,
        search: this.search,
        courseId: this.$route.params.courseId
      }).then(res => {
        this.totalRows = res.total;
        this.items = res.docs
        this.itemsLoaded = true;
      })
    },
    getExam() {
      this.itemsLoaded = false
      this.fetchExam({id: this.$route.params.examId}).then(res => {
        this.exam = res
        this.itemsLoaded = true
      })
    },
    getCoursesForFormSelect() {
      let filter = {search: this.jointCourseFilter}
      this.fetchCourses({listType: 'select', ...filter}).then(res => {
        this.formSelectJointCourses = res.docs.filter(doc => doc.id != this.$route.params.courseId);
      })
    },

    handleQuestionSubmit() {
      this.addSubmitted = true;
      this.$v.addForm.$touch();

      if (this.$v.addForm.$invalid) {
        return;
      } else {
        this.addForm.type = this.selectedQuestionType;
        if (this.selectedQuestionType === "multiple") {
          const correctAnswerIndex = this.correctAnswerIndex;
          const emptyOptionIndex = this.multipleChoiceOptions.findIndex(option => option.option.trim() === '');
          if (emptyOptionIndex !== -1) {
            this.multipleChoiceOptions[emptyOptionIndex].option = null;
          }
          this.multipleChoiceOptions.forEach((option, index) => {
            if (index === correctAnswerIndex) {
              option.correctAnswerOption = true;
            } else {
              option.correctAnswerOption = false;
            }
          });
          this.addForm.options = this.multipleChoiceOptions.map((option) => option);
        } else if (this.selectedQuestionType === "single") {
          delete this.addForm.options
        }
        let data = JSON.parse(JSON.stringify(this.addForm));
        const courseId = this.$route.params.courseId;
        const examId = this.$route.params.examId;
        this.createQuestion({
          data,
          courseId,
          examId,
        })
            .then(() => {
              this.toastMessage = "Soru başarıyla eklendi!";
              this.toastAction = "success";
              this.showToast = true;
              setTimeout(() => {
                this.showToast = false;
              }, 3000);
              this.showContentModal = false;
              this.getQuestions();
              this.addForm.name = "";
              this.addForm.isActive = "";
              this.selectedQuestionType = "";
              // Şıkları sıfırla
              this.multipleChoiceOptions.forEach((option) => {
                option.correctAnswerOption = false;
              });
              this.correctAnswerIndex = -1;
            })
            .catch(() => {
              return;
            });
      }
    },
    handleQuestionEditSubmit() {
      this.editSubmitted = true;
      this.editFormError = ""
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {
        this.editForm.type = this.selectedQuestionType;
        if (this.selectedQuestionType === "multiple") {
          const correctAnswerIndex = this.correctAnswerIndex;
          const emptyOptionIndex = this.multipleChoiceOptions.findIndex(option => option.option.trim() === '');
          if (emptyOptionIndex !== -1) {
            this.multipleChoiceOptions[emptyOptionIndex].option = null;
          }
          this.multipleChoiceOptions.forEach((option, index) => {
            if (index === correctAnswerIndex) {
              option.correctAnswerOption = true;
            } else {
              option.correctAnswerOption = false;
            }
          });
          this.editForm.options = this.multipleChoiceOptions.map((option) => option);
        } else if (this.selectedQuestionType === "single") {
          delete this.editForm.options
        }

        let data = JSON.parse(JSON.stringify(this.editForm));
        this.updateQuestion({
          courseId: this.$route.params.courseId,
          examId: this.$route.params.examId,
          questionId: this.editId,
          data
        }).then(() => {
          this.toastMessage = "Soru başarıyla düzenlendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.questionEditModal = false;
          this.getQuestions();

          this.editForm.type = "";
          this.editForm.name = "";
          this.editForm.options = [];
          this.editForm.correctAnswerText= null;
          this.editForm.isActive= false;
          this.correctAnswerIndex = -1
          this.multipleChoiceOptions= [
            {option: 'Şık 1', correctAnswerOption: false},
            {option: 'Şık 2', correctAnswerOption: false},
            {option: 'Şık 3', correctAnswerOption: false},
            {option: 'Şık 4', correctAnswerOption: false},
          ];
        }).catch((err) => {
          if (err == 'TCNUMBER_ALREADY_USE') {
            this.editFormError = "Girilen TC numarasına sahip bir content bulunmaktadır."
          } else {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          }
        })
      }
    },
    handleQuestionDeleteSubmit() {
      const courseId = this.$route.params.courseId;
      const examId = this.$route.params.examId;
      this.deleteQuestion({
        questionId: this.deleteId, courseId,
        examId
      }).then(() => {

        this.deleteModal = false;
        this.toastMessage = "Soru başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getQuestions();
      })
    },
    openQuestionAdd() {
      this.jointCourseFilter = ''
      this.showContentModal = true;
    },
    openQuestionEdit(question) {
      this.editForm.name = question.name;
      this.editId = question.id;
      this.selectedQuestionType = question.type;
      this.editForm.isActive = question.isActive;
      this.questionEditModal = true;
      this.multipleChoiceOptions = []
      question.options.map((option, index) => {
        this.multipleChoiceOptions.push({option: option.option, correctAnswerOption: option.correctAnswerOption});
        if(option.correctAnswerOption){
          this.correctAnswerIndex = index;
        }
      })
      /* eslint-disable no-console */
      console.log(this.editForm)
    },

    openQuestionDelete(question) {
      if (question.email === this.currentUser.email) {
        this.noDeleteModal = true;
      } else {
        this.deleteId = question.id;
        this.deleteModal = true;
      }
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">

      <!--    questions işlemleri-->
      <div class="col-12">
        <!--        {{courseId}} - {{examId}}-->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex align-items-center">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <h5>Sorular</h5>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="openQuestionAdd"
                >
                  Soru Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="items"
                  :fields="questionFields"
                  responsive="sm"
              >
                <template v-slot:cell(type)="data">
                  {{ data.item.type === 'single' ? 'Serbest Alan' : "Çoktan Seçmeli" }}
                </template>

                <template v-slot:cell(courseId)="data">
                  {{ data.item.courseId.name }}
                </template>
                <template v-slot:cell(name)="data">
                  {{ data.item.name }}
                </template>
                <template v-slot:cell(duration)="data">
                  {{ data.item.duration }}
                </template>
                <template v-slot:cell(isActive)="data">
                  <span v-show="data.item.isActive"
                        class="badge badge-pill badge-soft-success font-size-13">Aktif</span>
                  <span v-show="!data.item.isActive"
                        class="badge badge-pill badge-soft-danger font-size-13">Pasif</span>
                </template>
                <template v-slot:cell(detail)="data">
                  <button
                      class="btn btn-info d-flex py-2"
                      @click="$router.push({name:'contentDetail',params:{questionId: data.item.id}})"
                  >
                    <i :class="`bx bxs-detail bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(edit)="data">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-warning d-flex py-2"
                      @click="openQuestionEdit(data.item)"
                  >
                    <i :class="`bx bxs-edit bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-danger d-flex py-2"
                      @click="openQuestionDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="lg" v-model="showContentModal" title="Soru Ekle" hide-footer>
        <form @submit.prevent="handleQuestionSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Başlık</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Başlık giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Başlık girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="examType">Soru Tipi Seçiniz</label>
                <select id="examType" v-model="selectedQuestionType" class="form-control">
                  <option value="">Soru Tipi Seçiniz</option>
                  <option v-for="(examType, index) in options" :key="index" :value="examType.value">
                    {{ examType.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-12" v-if="selectedQuestionType === 'multiple'">
              <label class="">Şıklar</label>
              <div class="mb-3">


                <div v-for="(option, index) in multipleChoiceOptions" :key="index" class="row">

                  <div class="col-10 mb-3">
                    <input
                        :id="'option' + (index + 1)"
                        type="text"
                        v-model="option.option"
                        class="form-control"
                        :placeholder="'Şık ' + (index + 1)"

                    /></div>
                  <div class="col-2 mt-2">

                    <label class="" :for="'correctAnswerOption' + (index + 1)">
                    <span class="">  <input
                        :id="'correctAnswerOption' + (index + 1)"
                        type="radio"
                        :value="index"
                        v-model="correctAnswerIndex"
                        name="correctAnswerGroup"
                        class="form-radio"
                    /></span>

                      Doğru Cevap
                    </label>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-12" v-if="selectedQuestionType === 'single'">
              <div class="mb-3">
                <label for="name">Soru Giriniz</label>
                <textarea
                    id="name"
                    type="text"
                    v-model="addForm.correctAnswerText"
                    class="form-control"
                    placeholder="Soru Giriniz giriniz"
                ></textarea>

              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="isActive" class="me-2">Durum</label>
                <input
                    id="isActive"
                    type="checkbox"
                    v-model="addForm.isActive"
                    class="form-check-input"
                />
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showContentModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Soru Ekle
            </b-button>
          </div>
        </form>
      </b-modal>
      <b-modal size="lg" v-model="questionEditModal" title="Soruyu düzenle" hide-footer>
        <form @submit.prevent="handleQuestionEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Başlık</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Başlık giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Başlık girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="examType">Soru Tipi Seçiniz</label>
                <!--                <select id="examType" v-model="selectedQuestionType" class="form-control">
                                  <option value="">Soru Tipi Seçiniz</option>
                                  <option v-for="(examType, index) in options" :key="index" :value="examType.value">
                                    {{ examType.label }}
                                  </option>
                                </select>-->
                <select id="examType" v-model="selectedQuestionType" class="form-control">
                  <option value="multiple">Çoktan Seçmeli</option>
                  <option value="single">Serbest Alan</option>
                </select>

              </div>
            </div>
            <div class="col-12" v-if="selectedQuestionType === 'multiple'">
              <label class="">Şıklar</label>
              <div class="mb-3">
                <div v-for="(option, index) in multipleChoiceOptions" :key="index" class="row">
                  <div class="col-10 mb-3">
                    <input
                        :id="'option' + (index + 1)"
                        type="text"
                        v-model="option.option"
                        class="form-control"
                        :placeholder="'Şık ' + (index + 1)"

                    /></div>
                  <div class="col-2 mt-2">
                    <label class="" :for="'correctAnswerOption' + (index + 1)">
                    <span class="">  <input
                        :id="'correctAnswerOption' + (index + 1)"
                        type="radio"
                        :value="index"
                        v-model="correctAnswerIndex"
                        name="correctAnswerGroup"
                        class="form-radio"
                    /></span>
                      Doğru Cevap
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" v-if="selectedQuestionType === 'single'">
              <div class="mb-3">
                <label for="name">Soru Giriniz</label>
                <textarea
                    id="name"
                    type="text"
                    v-model="editForm.correctAnswerText"
                    class="form-control"
                    placeholder="Soru Giriniz giriniz"
                ></textarea>

              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="isActive" class="me-2">Durum</label>
                <input
                    id="isActive"
                    type="checkbox"
                    v-model="editForm.isActive"
                    class="form-check-input"
                />
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="questionEditModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Sınavı düzenle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu soruyu silmek istediğinize emin misiniz? Silinmiş içeriği geri alamazsınız.
              </p>
              <form @submit.prevent="handleQuestionDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız içeriği silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.customSelect .dropdown-menu {
  width: 100% !important;
}

.customSelect .btn {
  text-align: left;
}

.pill span {
  padding: 6px 12px 4px 12px;
}
</style>

